/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import logo from "./loj.jpg";
import hamburgerMenu from "./assets/hum.png";
import close from "./assets/close.png";
import { Crmroutes } from "../Routes";
import img from "./profile.png";
import img2 from "./user.png";
import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  deleteDoc,
  doc,
  increment,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { app, db } from "./Auth/Config/Config";
import { getAuth } from "firebase/auth";
import "./n.css";

const Navbar = ({ user, loading }) => {
  const [toggle, setToggle] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [inventoryDropdown, setInventoryDropdown] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth(app);

  const navigationItems = [
    { name: "Home", path: "/", hasDropdown: false },
    {
      name: "Our Services",
      hasDropdown: true,
      dropdownItems: [
        {
          name: "Management Consultancy",
          path: "/services/management-consultancy",
        },
      ],
    },
    {
      name: "Inventory",
      hasDropdown: true,
      dropdownItems: [
        {
          name: "Residential Leasing",
          path: Crmroutes.ResidentialLeasing.path,
          icon: "🏠",
        },
        {
          name: "Residential Sale",
          path: Crmroutes.ResidentialSale.path,
          icon: "🏡",
        },
        {
          name: "Commercial Leasing",
          path: Crmroutes.CommercialLeasing.path,
          icon: "🏢",
        },
        {
          name: "Commercial Sale",
          path: Crmroutes.CommercialSale.path,
          icon: "🏬",
        },
        {
          name: "Hotels Leasing",
          path: Crmroutes.HotelsLeasing.path,
          icon: "🏨",
        },
        {
          name: "Hotels Sale",
          path: Crmroutes.HotelsSale.path,
          icon: "🏩",
        },
        {
          name: "Commercial Entities",
          path: Crmroutes.CommercialEntitiesSale.path,
          icon: "💼",
        },
        { name: "Land Sale", path: Crmroutes.LandSale.path, icon: "🌳" },
        {
          name: "Land Leasing",
          path: Crmroutes.LandLeasing.path,
          icon: "🌾",
        },
        {
          name: "Miscellaneous",
          path: Crmroutes.MiscellaneousInventory.path,
          icon: "✨",
        },
      ],
    },
    { name: "About Us", path: "/about", hasDropdown: false },
    { name: "Blog", path: "/blog", hasDropdown: false },
    { name: "Contact Us", path: "/contact", hasDropdown: false },
  ];



  const handleClick = () => setToggle(!toggle);

  const handleLoginClick = () => {
    localStorage.setItem("loginFlag", true);
    const loginEvent = new Event("loginEvent");
    window.dispatchEvent(loginEvent);
  };

  const handlePhoneVerification = () => {
    localStorage.setItem("mobileFlag", true);
    const loginEvent = new Event("phoneVerification");
    window.dispatchEvent(loginEvent);
  };

  const handleAddItem = () => {
    const user = auth.currentUser;
    if (user && user.phoneNumber) {
      localStorage.setItem("addItemFlag", true);
      const loginEvent = new Event("addItemEvent");
      window.dispatchEvent(loginEvent);
    } else {
      handlePhoneVerification();
    }
  };

  const [messageBadge, setmessageBadge] = useState(0);
  const messagesFetch = async (uid) => {
    setmessageBadge(0);
    const docRef = collection(db, "product-messages");
    const q = query(docRef, where("uid", "==", auth.currentUser.uid));
    let badge = 0;
    onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          badge = change.doc.data().user_badge + badge;
          setmessageBadge(badge);
        }
        if (change.type === "modified") {
          setmessageBadge(badge + 1);
        }
      });
    });
  };

  useEffect(() => {
    if (user) {
      messagesFetch();
    }
  }, [user]);

  const [notifications, setnotifications] = useState([]);

  useEffect(() => {
    if (!user) return;

    const fetchNotifications = async () => {
      setnotifications([]);
      const q = query(
        collection(db, "users", user.uid, "notification"),
        orderBy("createdAt", "desc")
      );

      onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            setnotifications((prev) => [
              ...prev,
              { id: change.doc.id, data: change.doc.data() },
            ]);
          }
          if (change.type === "modified") {
            setnotifications((prev) =>
              prev.map((notification) =>
                notification.id === change.doc.id
                  ? { id: change.doc.id, data: change.doc.data() }
                  : notification
              )
            );
          }
          if (change.type === "removed") {
            setnotifications((prev) =>
              prev.filter((notification) => notification.id !== change.doc.id)
            );
          }
        });
      });
    };

    fetchNotifications();
    return () => {
      setnotifications([]);
    };
  }, [user]);

  const [isOpen, setIsOpen] = useState(false);

  const handleIconClick = () => {
    setIsOpen(!isOpen);
  };

  const deleteNotification = async (data) => {
    await deleteDoc(
      doc(db, "users", auth.currentUser.uid, "notification", data.id)
    );
    if (data.data.read === false) {
      await updateDoc(doc(db, "users", auth.currentUser.uid), {
        notification_count: increment(-1),
      });
    }
  };

  const handleNotification = async () => {
    await updateDoc(doc(db, "users", auth.currentUser.uid), {
      notification_count: 0,
    });
  };

  return (
    <div>
      <nav className="w-full h-22 fixed top-0 z-50 bg-white border-b border-gray-100/50 transition-all duration-300">
        <div className="max-w-9xl mx-auto px-4 sm:px-6 p-2 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3]/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500 transform group-hover:scale-105"></div>
                <img
                  src={logo}
                  className="h-14 w-auto rounded-xl transition-all duration-300 relative z-10"
                  alt="Logo"
                />
                <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#1ea1f3]/30 transition-all duration-500"></div>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-1">
              {navigationItems.map((item, index) => (
                <div key={index} className="relative group">
                  <Link
                    to={item.path}
                    className="relative text-gray-700 hover:text-white font-medium text-sm transition-all duration-500 py-3 px-6 rounded-2xl flex items-center group/nav-item overflow-hidden"
                    onMouseEnter={() => {
                      if (item.hasDropdown) {
                        if (item.name === "Our Services") {
                          setServicesDropdown(true);
                          setInventoryDropdown(false);
                        } else if (item.name === "Inventory") {
                          setInventoryDropdown(true);
                          setServicesDropdown(false);
                        }
                      }
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 rounded-2xl transform scale-x-0 group-hover/nav-item:scale-x-100 transition-transform duration-500 origin-left"></div>
                    <div className="absolute inset-0 border-2 border-transparent rounded-2xl group-hover/nav-item:border-[#1ea1f3]/50 transition-all duration-300"></div>
                    <span className="relative z-10 transition-colors duration-300 group-hover/nav-item:text-white">
                      {item.name}
                    </span>
                    {item.hasDropdown && (
                      <svg
                        className="ml-2 h-4 w-4 transition-transform duration-500 group-hover/nav-item:rotate-180 relative z-10 group-hover/nav-item:text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </Link>

                  {/* Dropdown */}
                  {item.hasDropdown && (
                    <div
                      className={`absolute left-0 mt-2 ${item.name === "Inventory" ? "w-96" : "w-80"
                        } bg-white/90 backdrop-blur-lg rounded-2xl shadow-2xl border border-gray-100/50 py-3 transform transition-all duration-500 ${(item.name === "Our Services" && servicesDropdown) ||
                          (item.name === "Inventory" && inventoryDropdown)
                          ? "opacity-100 translate-y-0 visible scale-100"
                          : "opacity-0 -translate-y-4 invisible scale-95"
                        }`}
                      onMouseEnter={() => {
                        if (item.name === "Our Services")
                          setServicesDropdown(true);
                        if (item.name === "Inventory")
                          setInventoryDropdown(true);
                      }}
                      onMouseLeave={() => {
                        if (item.name === "Our Services")
                          setServicesDropdown(false);
                        if (item.name === "Inventory")
                          setInventoryDropdown(false);
                      }}
                      style={{
                        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                        background:
                          "linear-gradient(135deg, rgba(255,255,255,0.90) 0%, rgba(248,250,252,0.90) 100%)",
                      }}
                    >
                      <div className="px-6 py-3 border-b border-gray-100/30 mb-2">
                        <span className="text-sm font-semibold bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 bg-clip-text text-transparent">
                          {item.name}
                        </span>
                      </div>

                      {item.name === "Inventory" ? (
                        <div className="grid grid-cols-2 gap-1 px-2">
                          {item.dropdownItems.map(
                            (dropdownItem, dropdownIndex) => (
                              <Link
                                key={dropdownIndex}
                                to={dropdownItem.path}
                                className="block px-4 py-3 text-sm text-gray-700 hover:text-white transition-all duration-500 group/dropdown-item relative rounded-xl overflow-hidden"
                              >
                                <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-xl transform scale-x-0 group-hover/dropdown-item:scale-x-100 transition-transform duration-500 origin-left"></div>
                                <span className="relative z-10 flex items-center gap-2 transition-all duration-300">
                                  <span className="text-lg">
                                    {dropdownItem.icon}
                                  </span>
                                  <span className="font-medium text-xs group-hover/dropdown-item:text-white">
                                    {dropdownItem.name}
                                  </span>
                                </span>
                              </Link>
                            )
                          )}
                        </div>
                      ) : (
                        item.dropdownItems.map(
                          (dropdownItem, dropdownIndex) => (
                            <Link
                              key={dropdownIndex}
                              to={dropdownItem.path}
                              className="block px-6 py-4 text-sm text-gray-700 hover:text-white transition-all duration-500 group/dropdown-item relative rounded-xl mx-2 my-1 overflow-hidden"
                            >
                              <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-xl transform scale-x-0 group-hover/dropdown-item:scale-x-100 transition-transform duration-500 origin-left"></div>
                              <div className="absolute left-4 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-white rounded-full opacity-0 group-hover/dropdown-item:opacity-100 transition-all duration-500 group-hover/dropdown-item:scale-150"></div>
                              <span className="relative z-10 flex items-center transition-all duration-300 group-hover/dropdown-item:translate-x-3">
                                <span className="font-medium group-hover/dropdown-item:text-white">
                                  {dropdownItem.name}
                                </span>
                              </span>
                              <svg
                                className="absolute right-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-white opacity-0 group-hover/dropdown-item:opacity-100 transition-all duration-500 group-hover/dropdown-item:translate-x-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M9 5l7 7-7 7"
                                />
                              </svg>
                            </Link>
                          )
                        )
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* User Actions */}
            {user ? (
              <div className="hidden lg:flex items-center space-x-3">
                {/* Messages */}
                <div className="relative">
                  <button
                    className="p-3 text-gray-600 hover:text-white rounded-2xl transition-all duration-500 group/icon relative overflow-hidden"
                    onClick={() => navigate(Crmroutes.AllMessage.path)}
                  >
                    <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/icon:scale-100 transition-transform duration-500"></div>
                    <div className="relative z-10 flex items-center">
                      <svg
                        className="h-5 w-5 transition-colors duration-300 group-hover/icon:text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    {messageBadge > 0 && (
                      <span className="absolute top-1 right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-lg border border-white/20 transform group-hover/icon:scale-110 transition-transform duration-300 z-20">
                        {messageBadge}
                      </span>
                    )}
                  </button>
                </div>

                {/* Notifications */}
                <div className="relative">
                  <button
                    className="p-3 text-gray-600 hover:text-white rounded-2xl transition-all duration-500 group/icon relative overflow-hidden"
                    onClick={handleIconClick}
                  >
                    <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/icon:scale-100 transition-transform duration-500"></div>
                    <div className="relative z-10 flex items-center">
                      <svg
                        className="h-5 w-5 transition-colors duration-300 group-hover/icon:text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 17h5l-5 5v-5zM4 19h10a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    {user.notification_count > 0 && (
                      <span className="absolute top-1 right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-lg border border-white/20 transform group-hover/icon:scale-110 transition-transform duration-300 z-20">
                        {user.notification_count}
                      </span>
                    )}
                  </button>

                  {/* Notifications Dropdown */}
                  {isOpen && (
                    <div className="absolute right-0 mt-3 w-96 bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-blue-100/50 z-50 transform transition-all duration-500 scale-100 opacity-100">
                      <div className="bg-gradient-to-r from-[#1ea1f3]/5 to-[#1ea1f3]/10 border-b border-blue-100/30 px-6 py-4 rounded-t-2xl">
                        <div className="flex justify-between items-center">
                          <h3 className="text-lg font-semibold bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 bg-clip-text text-transparent">
                            Notifications
                          </h3>
                          <button
                            onClick={handleNotification}
                            className="text-sm bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 text-white px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                          >
                            Mark all as read
                          </button>
                        </div>
                      </div>
                      <div className="max-h-80 overflow-y-auto custom-scrollbar">
                        {notifications.map((doc, index) => (
                          <div
                            key={index}
                            className="relative px-6 py-4 hover:bg-gradient-to-r from-[#1ea1f3]/5 to-transparent border-b border-blue-100/20 last:border-b-0 group/notification transition-all duration-500"
                          >
                            <button
                              className="absolute top-3 right-3 text-gray-400 hover:text-white w-6 h-6 rounded-full hover:bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center transition-all duration-300 transform hover:scale-110 group/delete"
                              onClick={() => deleteNotification(doc)}
                            >
                              <div className="absolute inset-0 bg-red-500 rounded-full opacity-0 group-hover/delete:opacity-100 transition-opacity duration-300"></div>
                              <span className="relative z-10 text-sm font-bold">
                                ×
                              </span>
                            </button>
                            <p className="text-sm text-gray-700 pr-8 leading-relaxed group-hover/notification:text-gray-900 transition-colors duration-300">
                              {doc.data.message}
                            </p>
                            <div className="absolute bottom-0 left-6 right-6 h-0.5 bg-gradient-to-r from-transparent via-[#1ea1f3]/30 to-transparent transform scale-x-0 group-hover/notification:scale-x-100 transition-transform duration-500"></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Add Button */}
                <button
                  onClick={handleAddItem}
                  className="bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-6 py-3 rounded-2xl font-medium transition-all duration-500 flex items-center space-x-2 shadow-lg hover:shadow-xl transform hover:-translate-y-1 relative overflow-hidden group/add-btn"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/add-btn:translate-x-[100%] transition-transform duration-1000"></div>
                  <div className="absolute inset-0 rounded-2xl border-2 border-white/30 transform scale-105 opacity-0 group-hover/add-btn:opacity-100 group-hover/add-btn:scale-100 transition-all duration-500"></div>
                  <svg
                    className="h-5 w-5 relative z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                  <span className="relative z-10 font-semibold">Add New</span>
                </button>

                {/* User Profile */}
                <Link
                  to={Crmroutes.Profile.path}
                  className="flex items-center space-x-3 hover:bg-gradient-to-r from-[#1ea1f3]/10 to-[#1ea1f3]/5 rounded-2xl p-3 transition-all duration-500 group/profile relative overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-x-0 group-hover/profile:scale-x-100 transition-transform duration-500 origin-left"></div>
                  
                  <div className="flex flex-col items-end relative z-10">
                    <span className="text-sm font-semibold text-gray-900 transition-colors duration-300 group-hover/profile:text-white">
                      {user.name}
                    </span>
                    {user.place && (
                      <span className="text-[10px] text-gray-500 font-medium transition-colors duration-300 group-hover/profile:text-white/80 flex items-center gap-0.5 mt-0.5">
                        <svg className="h-3 w-3 text-[#1ea1f3] group-hover/profile:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        </svg>
                        {user.place}
                      </span>
                    )}
                  </div>

                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/70 rounded-full opacity-0 group-hover/profile:opacity-100 transition-opacity duration-500 transform group-hover/profile:scale-110 blur-sm"></div>
                    <img
                      src={user ? user.photoURL || img : img2}
                      alt="User Avatar"
                      className="w-9 h-9 rounded-full border-2 border-gray-200 group-hover/profile:border-white/50 relative z-10 transition-all duration-500 transform group-hover/profile:scale-110"
                      onError={(e) => {
                        e.currentTarget.src = img2;
                      }}
                    />
                    <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white z-20 group-hover/profile:border-[#1ea1f3] transition-colors duration-300"></div>
                  </div>
                </Link>
              </div>
            ) : (
              <div className="hidden lg:flex items-center">
                <button
                  className="bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-8 py-3 rounded-2xl font-semibold transition-all duration-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden group/get-started"
                  onClick={handleLoginClick}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/get-started:translate-x-[100%] transition-transform duration-1000"></div>
                  <span className="relative z-10">Get Started</span>
                  <div className="absolute inset-0 rounded-2xl border-2 border-white/30 transform scale-105 opacity-0 group-hover/get-started:opacity-100 group-hover/get-started:scale-100 transition-all duration-500"></div>
                </button>
              </div>
            )}

            {/* Mobile Actions */}
            <div className="flex items-center space-x-2 lg:hidden">
              <button
                onClick={handleClick}
                className="p-3 rounded-2xl text-gray-600 hover:text-white transition-all duration-500 relative group/mobile-btn overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/mobile-btn:scale-100 transition-transform duration-500"></div>
                <img
                  src={toggle ? close : hamburgerMenu}
                  alt="Toggle Menu"
                  className="h-6 w-6 relative z-10 transition-transform duration-300 group-hover/mobile-btn:scale-110"
                />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation - Fixed: No white space when closed */}
        {/* Mobile Navigation - Fixed Scroll + No White Space */}
        <div
          className={`
    lg:hidden transition-all duration-700 ease-out
    ${toggle
              ? "max-h-[70vh] opacity-100 pointer-events-auto"
              : "max-h-0 opacity-0 pointer-events-none"
            }
  `}
        >
          <div className="mobile-menu-scroll overflow-y-auto max-h-[70vh] bg-gradient-to-b from-white/95 to-blue-50/95 backdrop-blur-lg border-t border-blue-100/30 px-4 py-6 space-y-2">
            {navigationItems.map((item, index) => (
              <div key={index}>
                {!item.hasDropdown ? (
                  <Link
                    to={item.path}
                    className="block px-6 py-4 text-gray-800 hover:text-white rounded-2xl transition-all duration-500 font-medium group/mobile-item relative overflow-hidden"
                    onClick={() => setToggle(false)}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-x-0 group-hover/mobile-item:scale-x-100 transition-transform duration-500 origin-left"></div>
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#1ea1f3] to-[#1ea1f3]/50 rounded-r-full transform scale-y-0 group-hover/mobile-item:scale-y-100 transition-transform duration-500 origin-top"></div>
                    <span className="relative z-10 flex items-center transition-transform duration-300 group-hover/mobile-item:translate-x-3">
                      {item.name}
                    </span>
                    <svg
                      className="absolute right-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-white opacity-0 group-hover/mobile-item:opacity-100 transition-all duration-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </Link>
                ) : (
                  <div className="space-y-1">
                    <div className="px-6 py-3 text-gray-900 font-semibold text-sm">
                      {item.name}
                    </div>
                    <div className="space-y-1 pl-4">
                      {item.dropdownItems.map((dropdownItem, dropdownIndex) => (
                        <Link
                          key={dropdownIndex}
                          to={dropdownItem.path}
                          className="block px-4 py-3 text-gray-700 hover:text-white rounded-xl transition-all duration-500 text-sm group/mobile-dropdown relative overflow-hidden"
                          onClick={() => setToggle(false)}
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3]/80 to-[#1ea1f3]/60 rounded-xl transform scale-x-0 group-hover/mobile-dropdown:scale-x-100 transition-transform duration-500 origin-left"></div>
                          <span className="relative z-10 flex items-center gap-2">
                            {dropdownItem.icon && (
                              <span>{dropdownItem.icon}</span>
                            )}
                            <span className="group-hover/mobile-dropdown:text-white">
                              {dropdownItem.name}
                            </span>
                          </span>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* ──────────────────────────────────────────────────────────────── */}
            {/*  MOBILE NAV – show “Add New”, user profile & login button      */}
            {/* ──────────────────────────────────────────────────────────────── */}
            {user && (
              <div className="relative">
                <button
                  className="p-3 text-gray-600 hover:text-white rounded-2xl transition-all duration-500 group/icon relative overflow-hidden"
                  onClick={() => navigate(Crmroutes.AllMessage.path)}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/icon:scale-100 transition-transform duration-500"></div>
                  <div className="relative z-10 flex items-center">
                    <svg
                      className="h-5 w-5 transition-colors duration-300 group-hover/icon:text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  {messageBadge > 0 && (
                    <span className="absolute top-1 right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-lg border border-white/20 transform group-hover/icon:scale-110 transition-transform duration-300 z-20">
                      {messageBadge}
                    </span>
                  )}
                </button>
              </div>
            )}
            {user && (
              <div className="relative">
                <button
                  className="p-3 text-gray-600 hover:text-white rounded-2xl transition-all duration-500 group/icon relative overflow-hidden"
                  onClick={handleIconClick}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/icon:scale-100 transition-transform duration-500"></div>
                  <div className="relative z-10 flex items-center">
                    <svg
                      className="h-5 w-5 transition-colors duration-300 group-hover/icon:text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 17h5l-5 5v-5zM4 19h10a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  {user.notification_count > 0 && (
                    <span className="absolute top-1 right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-lg border border-white/20 transform group-hover/icon:scale-110 transition-transform duration-300 z-20">
                      {user.notification_count}
                    </span>
                  )}
                </button>

                {/* Notifications Dropdown */}
                {isOpen && (
                  <div className="absolute right-0 mt-3 w-96 bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-blue-100/50 z-50 transform transition-all duration-500 scale-100 opacity-100">
                    <div className="bg-gradient-to-r from-[#1ea1f3]/5 to-[#1ea1f3]/10 border-b border-blue-100/30 px-6 py-4 rounded-t-2xl">
                      <div className="flex justify-between items-center">
                        <h3 className="text-lg font-semibold bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 bg-clip-text text-transparent">
                          Notifications
                        </h3>
                        <button
                          onClick={handleNotification}
                          className="text-sm bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 text-white px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                        >
                          Mark all as read
                        </button>
                      </div>
                    </div>
                    <div className="max-h-80 overflow-y-auto custom-scrollbar">
                      {notifications.map((doc, index) => (
                        <div
                          key={index}
                          className="relative px-6 py-4 hover:bg-gradient-to-r from-[#1ea1f3]/5 to-transparent border-b border-blue-100/20 last:border-b-0 group/notification transition-all duration-500"
                        >
                          <button
                            className="absolute top-3 right-3 text-gray-400 hover:text-white w-6 h-6 rounded-full hover:bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center transition-all duration-300 transform hover:scale-110 group/delete"
                            onClick={() => deleteNotification(doc)}
                          >
                            <div className="absolute inset-0 bg-red-500 rounded-full opacity-0 group-hover/delete:opacity-100 transition-opacity duration-300"></div>
                            <span className="relative z-10 text-sm font-bold">
                              ×
                            </span>
                          </button>
                          <p className="text-sm text-gray-700 pr-8 leading-relaxed group-hover/notification:text-gray-900 transition-colors duration-300">
                            {doc.data.message}
                          </p>
                          <div className="absolute bottom-0 left-6 right-6 h-0.5 bg-gradient-to-r from-transparent via-[#1ea1f3]/30 to-transparent transform scale-x-0 group-hover/notification:scale-x-100 transition-transform duration-500"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            <div
              className={`
    lg:hidden transition-all duration-700 ease-out
    ${toggle
                  ? "max-h-[70vh] opacity-100 pointer-events-auto"
                  : "max-h-0 opacity-0 pointer-events-none"
                }
  `}
            >
              {/* Scrollable inner container */}
              <div className="mobile-menu-scroll overflow-y-auto max-h-[70vh] backdrop-blur-lg  px-4 py-6 space-y-4">
                {/* ── Navigation items ── */}
                {navigationItems.map((item, index) => (
                  <div key={index}>
                    {/* … same code you already have for items & dropdowns … */}
                  </div>
                ))}

                {/* ── USER ACTIONS (visible only when signed-in) ── */}
                {user ? (
                  <div className="flex flex-col space-y-3 pt-2 border-t border-blue-100/30">
                    {/* Add New */}
                    <button
                      onClick={() => {
                        handleAddItem();
                        setToggle(false);
                      }}
                      className="w-full bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-6 py-3 rounded-2xl font-medium transition-all duration-500 flex items-center justify-center space-x-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden group/add-btn"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/add-btn:translate-x-[100%] transition-transform duration-1000"></div>
                      <svg
                        className="h-5 w-5 relative z-10"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                      <span className="relative z-10 font-semibold">
                        Add New
                      </span>
                    </button>

                    {/* User Profile */}
                    <Link
                      to={Crmroutes.Profile.path}
                      onClick={() => setToggle(false)}
                      className="flex items-center space-x-3 p-3 rounded-2xl hover:bg-gradient-to-r hover:from-[#1ea1f3]/10 hover:to-[#1ea1f3]/5 transition-all duration-500 group/profile relative overflow-hidden"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-x-0 group-hover/profile:scale-x-100 transition-transform duration-500 origin-left"></div>

                      <div className="relative">
                        <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/70 rounded-full opacity-0 group-hover/profile:opacity-100 transition-opacity duration-500 transform group-hover/profile:scale-110 blur-sm"></div>
                        <img
                          src={user.photoURL || img}
                          alt="User"
                          className="w-9 h-9 rounded-full border-2 border-gray-200 group-hover/profile:border-white/50 relative z-10 transition-all duration-500 transform group-hover/profile:scale-110"
                          onError={(e) => (e.currentTarget.src = img2)}
                        />
                        <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white z-20 group-hover/profile:border-[#1ea1f3] transition-colors duration-300"></div>
                      </div>
                      
                      <div className="flex flex-col items-start relative z-10">
                        <span className="text-sm font-semibold text-gray-900 transition-colors duration-300 group-hover/profile:text-white">
                          {user.name}
                        </span>
                        {user.place && (
                          <span className="text-[10px] text-gray-500 font-medium transition-colors duration-300 group-hover/profile:text-white/85 flex items-center gap-0.5 mt-0.5">
                            <svg className="h-3 w-3 text-[#1ea1f3] group-hover/profile:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            </svg>
                            {user.place}
                          </span>
                        )}
                      </div>
                    </Link>
                  </div>
                ) : (
                  /* ── LOGIN BUTTON (visible when NOT signed-in) ── */
                  <button
                    className="w-full mt-4 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-6 py-4 rounded-2xl font-semibold transition-all duration-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden group/mobile-get-started"
                    onClick={() => {
                      handleLoginClick();
                      setToggle(false);
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/mobile-get-started:translate-x-[100%] transition-transform duration-1000"></div>
                    <span className="relative z-10">Get Started</span>
                  </button>
                )}
              </div>
            </div>
            {/* {!user && (
                <button
                  className="w-full mt-4 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-6 py-4 rounded-2xl font-semibold transition-all duration-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden group/mobile-get-started"
                  onClick={() => {
                    handleLoginClick();
                    setToggle(false);
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/mobile-get-started:translate-x-[100%] transition-transform duration-1000"></div>
                  <span className="relative z-10">Get Started</span>
                </button>
              )} */}
          </div>
        </div>
      </nav>

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .mobile-menu-scroll::-webkit-scrollbar {
          width: 6px;
        }
        .mobile-menu-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .mobile-menu-scroll::-webkit-scrollbar-thumb {
          background: #1ea1f3;
          border-radius: 3px;
        }
        .mobile-menu-scroll::-webkit-scrollbar-thumb:hover {
          background: #1a91e0;
        }

        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: linear-gradient(to bottom, #f1f1f1, #e3f2fd);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #1ea1f3, #1ea1f3/80);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #1ea1f3;
        }

        * {
          transition-property: color, background-color, border-color, transform,
            opacity;
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        }
      `}</style>
    </div>
  );
};

export default Navbar;

// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState, useEffect } from "react";
// import logo from "./loj.jpg";
// import hamburgerMenu from "./assets/hum.png";
// import close from "./assets/close.png";
// import { Crmroutes } from "../Routes";
// import PlacesAutocompleteComponent from "./PlacesAutocomplete";
// import CurrentLocation from "./Location/CurrentLocation";
// import img from "./profile.png";
// import img2 from "./user.png";
// import { useNavigate } from "react-router-dom";
// import { collection, deleteDoc, doc, increment, onSnapshot, orderBy, query, updateDoc, where } from "firebase/firestore";
// import { app, db } from "./Auth/Config/Config";
// import { getAuth  } from "firebase/auth";
// import AutocompleteWithRefine from "./Search/Autocomplete";
// import './n.css'

// const Navbar = ({ user, loading }) => {
//   const [toggle, setToggle] = useState(false);
//   const [scrollingUp, setScrollingUp] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [servicesDropdown, setServicesDropdown] = useState(false);
//   const [inventoryDropdown, setInventoryDropdown] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const navigate = useNavigate();
//   const auth = getAuth(app);

//   const navigationItems = [
//     { name: 'Home', path: '/', hasDropdown: false },
//     {
//       name: 'Our Services',
//       // path: '/services',
//       hasDropdown: true,
//       dropdownItems: [
//         { name: 'Management Consultancy', path: '/services/management-consultancy' },
//         // { name: 'Real Estate Consultancy', path: '/services/real-estate-consultancy' },
//         // { name: 'Financial Consultancy', path: '/services/financial-consultancy' }
//       ]
//     },
//     {
//       name: 'Inventory',
//       hasDropdown: true,
//       dropdownItems: [
//         { name: 'Residential Leasing', path: Crmroutes.ResidentialLeasing.path, icon: '🏠' },
//         { name: 'Residential Sale', path: Crmroutes.ResidentialSale.path, icon: '🏡' },
//         { name: 'Commercial Leasing', path: Crmroutes.CommercialLeasing.path, icon: '🏢' },
//         { name: 'Commercial Sale', path: Crmroutes.CommercialSale.path, icon: '🏬' },
//         { name: 'Hotels Leasing', path: Crmroutes.HotelsLeasing.path, icon: '🏨' },
//         { name: 'Hotels Sale', path: Crmroutes.HotelsSale.path, icon: '🏩' },
//         { name: 'Commercial Entities', path: Crmroutes.CommercialEntitiesSale.path, icon: '💼' },
//         { name: 'Land Sale', path: Crmroutes.LandSale.path, icon: '🌳' },
//         { name: 'Land Leasing', path: Crmroutes.LandLeasing.path, icon: '🌾' },
//         { name: 'Miscellaneous', path: Crmroutes.MiscellaneousInventory.path, icon: '✨' }
//       ]
//     },
//     { name: 'About Us', path: '/about', hasDropdown: false },
//     { name: 'Blog', path: '/blog', hasDropdown: false },
//     { name: 'Contact Us', path: '/contact', hasDropdown: false }
//   ];

//   const handleLocationClick = () => {
//     if (user) {
//       setShowDropdown(!showDropdown);
//     } else {
//       handleLoginClick();
//     }
//   };

//   const handleCloseDropdown = () => {
//     setShowDropdown(false);
//   };

//   useEffect(() => {
//     let prevScrollY = window.scrollY;
//     const handleScroll = () => {
//       const currentScrollY = window.scrollY;
//       setScrollingUp(prevScrollY > currentScrollY);
//       prevScrollY = currentScrollY;
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const handleClick = () => setToggle(!toggle);

//   const handleLoginClick = () => {
//     localStorage.setItem("loginFlag", true);
//     const loginEvent = new Event("loginEvent");
//     window.dispatchEvent(loginEvent);
//   };

//   const handlePhoneVerification = () => {
//     localStorage.setItem("mobileFlag", true);
//     const loginEvent = new Event("phoneVerification");
//     window.dispatchEvent(loginEvent);
//   };

//   const handleAddItem = () => {
//     const user = auth.currentUser;
//     if (user && user.phoneNumber) {
//       localStorage.setItem("addItemFlag", true);
//       const loginEvent = new Event("addItemEvent");
//       window.dispatchEvent(loginEvent);
//     } else {
//       handlePhoneVerification();
//     }
//   };

//   const [messageBadge, setmessageBadge] = useState(0);
//   const messagesFetch = async (uid) => {
//     setmessageBadge(0);
//     const docRef = collection(db, "product-messages");
//     const q = query(docRef, where("uid", "==", auth.currentUser.uid));
//     var badge = 0;
//     onSnapshot(q, (snapshot) => {
//       snapshot.docChanges().forEach((change) => {
//         if (change.type === "added") {
//           badge = change.doc.data().user_badge + badge;
//           setmessageBadge(badge);
//         }
//         if (change.type === "modified") {
//           setmessageBadge(badge + 1);
//         }
//       });
//     });
//   };

//   useEffect(() => {
//     if (user) {
//       messagesFetch();
//     }
//   }, [user]);

//   const [notifications, setnotifications] = useState([]);

//   useEffect(() => {
//     if (!user) return;

//     const fetchNotifications = async () => {
//       setnotifications([]);
//       const q = query(
//         collection(db, "users", user.uid, "notification"),
//         orderBy("createdAt", "desc")
//       );

//       onSnapshot(q, (snapshot) => {
//         snapshot.docChanges().forEach((change) => {
//           if (change.type === "added") {
//             setnotifications((prev) => [
//               ...prev,
//               { id: change.doc.id, data: change.doc.data() },
//             ]);
//           }
//           if (change.type === "modified") {
//             setnotifications((prev) =>
//               prev.map((notification) =>
//                 notification.id === change.doc.id
//                   ? { id: change.doc.id, data: change.doc.data() }
//                   : notification
//               )
//             );
//           }
//           if (change.type === "removed") {
//             setnotifications((prev) =>
//               prev.filter((notification) => notification.id !== change.doc.id)
//             );
//           }
//         });
//       });
//     };

//     fetchNotifications();
//     return () => {
//       setnotifications([]);
//     };
//   }, [user]);

//   const [isOpen, setIsOpen] = useState(false);

//   const handleIconClick = () => {
//     setIsOpen(!isOpen);
//   };

//   const deleteNotification = async (data) => {
//     await deleteDoc(
//       doc(db, "users", auth.currentUser.uid, "notification", data.id)
//     );
//     if (data.data.read === false) {
//       await updateDoc(doc(db, "users", auth.currentUser.uid), {
//         notification_count: increment(-1),
//       });
//     }
//   };

//   const handleNotification = async () => {
//     await updateDoc(doc(db, "users", auth.currentUser.uid), {
//       notification_count: 0,
//     });
//   };

//   return (
//     <div>
//       <nav className="w-full h-22 fixed top-0 z-50 bg-white border-b border-gray-100/50 transition-all duration-300">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 p-2 lg:px-8">
//           <div className="flex justify-between items-center h-20">
//             {/* Logo */}
//             <div className="flex-shrink-0">
//               <Link to="/" className="flex items-center group relative">
//                 <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3]/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-all duration-500 transform group-hover:scale-105"></div>
//                 <img
//                   src={logo}
//                   className="h-14 w-auto rounded-xl transition-all duration-300  relative z-10"
//                   alt="Logo"
//                 />
//                 {/* Animated border effect */}
//                 <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#1ea1f3]/30 transition-all duration-500"></div>
//               </Link>
//             </div>

//             {/* Desktop Navigation */}
//             <div className="hidden lg:flex items-center space-x-1">
//               {navigationItems.map((item, index) => (
//                 <div key={index} className="relative group">
//                   <a
//                     href={item.path}
//                     className="relative text-gray-700 hover:text-white font-medium text-sm transition-all duration-500 py-3 px-6 rounded-2xl flex items-center group/nav-item overflow-hidden"
//                     onMouseEnter={() => {
//                       if (item.hasDropdown) {
//                         if (item.name === 'Our Services') {
//                           setServicesDropdown(true);
//                           setInventoryDropdown(false);
//                         } else if (item.name === 'Inventory') {
//                           setInventoryDropdown(true);
//                           setServicesDropdown(false);
//                         }
//                       }
//                     }}
//                   >
//                     {/* Animated background fill */}
//                     <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 rounded-2xl transform scale-x-0 group-hover/nav-item:scale-x-100 transition-transform duration-500 origin-left"></div>

//                     {/* Border animation */}
//                     <div className="absolute inset-0 border-2 border-transparent rounded-2xl group-hover/nav-item:border-[#1ea1f3]/50 transition-all duration-300"></div>

//                     <span className="relative z-10 transition-colors duration-300 group-hover/nav-item:text-white">
//                       {item.name}
//                     </span>

//                     {item.hasDropdown && (
//                       <svg
//                         className="ml-2 h-4 w-4 transition-transform duration-500 group-hover/nav-item:rotate-180 relative z-10 group-hover/nav-item:text-white"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
//                       </svg>
//                     )}
//                   </Link>

//                   {/* Enhanced Dropdown Menu with filling animation */}
//                   {item.hasDropdown && (
//                     <div
//                       className={`absolute left-0 mt-2 ${item.name === 'Inventory' ? 'w-96' : 'w-80'} bg-white/90 backdrop-blur-lg rounded-2xl shadow-2xl border border-gray-100/50 py-3 transform transition-all duration-500 ${
//                         (item.name === 'Our Services' && servicesDropdown) || (item.name === 'Inventory' && inventoryDropdown)
//                           ? 'opacity-100 translate-y-0 visible scale-100'
//                           : 'opacity-0 -translate-y-4 invisible scale-95'
//                       }`}
//                       onMouseEnter={() => {
//                         if (item.name === 'Our Services') setServicesDropdown(true);
//                         if (item.name === 'Inventory') setInventoryDropdown(true);
//                       }}
//                       onMouseLeave={() => {
//                         if (item.name === 'Our Services') setServicesDropdown(false);
//                         if (item.name === 'Inventory') setInventoryDropdown(false);
//                       }}
//                       style={{
//                         boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
//                         background: 'linear-gradient(135deg, rgba(255,255,255,0.90) 0%, rgba(248,250,252,0.90) 100%)'
//                       }}
//                     >
//                       {/* Dropdown header with gradient */}
//                       <div className="px-6 py-3 border-b border-gray-100/30 mb-2">
//                         <span className="text-sm font-semibold bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 bg-clip-text text-transparent">
//                           {item.name}
//                         </span>
//                       </div>

//                       {item.name === 'Inventory' ? (
//                         <div className="grid grid-cols-2 gap-1 px-2">
//                           {item.dropdownItems.map((dropdownItem, dropdownIndex) => (
//                             <a
//                               key={dropdownIndex}
//                               href={dropdownItem.path}
//                               className="block px-4 py-3 text-sm text-gray-700 hover:text-white transition-all duration-500 group/dropdown-item relative rounded-xl overflow-hidden"
//                             >
//                               {/* Hover fill effect */}
//                               <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-xl transform scale-x-0 group-hover/dropdown-item:scale-x-100 transition-transform duration-500 origin-left"></div>

//                               <span className="relative z-10 flex items-center gap-2 transition-all duration-300">
//                                 <span className="text-lg">{dropdownItem.icon}</span>
//                                 <span className="font-medium text-xs group-hover/dropdown-item:text-white">
//                                   {dropdownItem.name}
//                                 </span>
//                               </span>
//                             </Link>
//                           ))}
//                         </div>
//                       ) : (
//                         item.dropdownItems.map((dropdownItem, dropdownIndex) => (
//                           <a
//                             key={dropdownIndex}
//                             href={dropdownItem.path}
//                             className="block px-6 py-4 text-sm text-gray-700 hover:text-white transition-all duration-500 group/dropdown-item relative rounded-xl mx-2 my-1 overflow-hidden"
//                           >
//                             {/* Hover fill effect */}
//                             <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-xl transform scale-x-0 group-hover/dropdown-item:scale-x-100 transition-transform duration-500 origin-left"></div>

//                             {/* Icon animation */}
//                             <div className="absolute left-4 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-white rounded-full opacity-0 group-hover/dropdown-item:opacity-100 transition-all duration-500 group-hover/dropdown-item:scale-150"></div>

//                             <span className="relative z-10 flex items-center transition-all duration-300 group-hover/dropdown-item:translate-x-3">
//                               <span className="font-medium group-hover/dropdown-item:text-white">
//                                 {dropdownItem.name}
//                               </span>
//                             </span>

//                             {/* Right arrow on hover */}
//                             <svg
//                               className="absolute right-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-white opacity-0 group-hover/dropdown-item:opacity-100 transition-all duration-500 group-hover/dropdown-item:translate-x-1"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                             </svg>
//                           </Link>
//                         ))
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* User Actions */}
//             {user ? (
//               <div className="hidden lg:flex items-center space-x-3">
//                 {/* Messages */}
//                 <div className="relative">
//                   <button
//                     className="p-3 text-gray-600 hover:text-white rounded-2xl transition-all duration-500 group/icon relative overflow-hidden"
//                     onClick={() => navigate(Crmroutes.AllMessage.path)}
//                   >
//                     {/* Background fill effect */}
//                     <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/icon:scale-100 transition-transform duration-500"></div>

//                     <div className="relative z-10 flex items-center">
//                       <svg className="h-5 w-5 transition-colors duration-300 group-hover/icon:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                       </svg>
//                     </div>

//                     {messageBadge > 0 && (
//                       <span className="absolute top-1 right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-lg border border-white/20 transform group-hover/icon:scale-110 transition-transform duration-300 z-20">
//                         {messageBadge}
//                       </span>
//                     )}
//                   </button>
//                 </div>

//                 {/* Notifications */}
//                 <div className="relative">
//                   <button
//                     className="p-3 text-gray-600 hover:text-white rounded-2xl transition-all duration-500 group/icon relative overflow-hidden"
//                     onClick={handleIconClick}
//                   >
//                     {/* Background fill effect */}
//                     <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/icon:scale-100 transition-transform duration-500"></div>

//                     <div className="relative z-10 flex items-center">
//                       <svg className="h-5 w-5 transition-colors duration-300 group-hover/icon:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5v-5zM4 19h10a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                       </svg>
//                     </div>

//                     {user.notification_count > 0 && (
//                       <span className="absolute top-1 right-1 bg-gradient-to-br from-red-500 to-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-lg border border-white/20 transform group-hover/icon:scale-110 transition-transform duration-300 z-20">
//                         {user.notification_count}
//                       </span>
//                     )}
//                   </button>

//                   {/* Enhanced Notifications Dropdown */}
//                   {isOpen && (
//                     <div className="absolute right-0 mt-3 w-96 bg-white/95 backdrop-blur-lg rounded-2xl shadow-2xl border border-blue-100/50 z-50 transform transition-all duration-500 scale-100 opacity-100">
//                       {/* Gradient header */}
//                       <div className="bg-gradient-to-r from-[#1ea1f3]/5 to-[#1ea1f3]/10 border-b border-blue-100/30 px-6 py-4 rounded-t-2xl">
//                         <div className="flex justify-between items-center">
//                           <h3 className="text-lg font-semibold bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 bg-clip-text text-transparent">
//                             Notifications
//                           </h3>
//                           <button
//                             onClick={handleNotification}
//                             className="text-sm bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 text-white px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-all duration-300 transform hover:scale-105"
//                           >
//                             Mark all as read
//                           </button>
//                         </div>
//                       </div>

//                       <div className="max-h-80 overflow-y-auto custom-scrollbar">
//                         {notifications.map((doc, index) => (
//                           <div key={index} className="relative px-6 py-4 hover:bg-gradient-to-r from-[#1ea1f3]/5 to-transparent border-b border-blue-100/20 last:border-b-0 group/notification transition-all duration-500">
//                             {/* Delete button with hover effect */}
//                             <button
//                               className="absolute top-3 right-3 text-gray-400 hover:text-white w-6 h-6 rounded-full hover:bg-gradient-to-r from-red-500 to-red-600 flex items-center justify-center transition-all duration-300 transform hover:scale-110 group/delete"
//                               onClick={() => deleteNotification(doc)}
//                             >
//                               <div className="absolute inset-0 bg-red-500 rounded-full opacity-0 group-hover/delete:opacity-100 transition-opacity duration-300"></div>
//                               <span className="relative z-10 text-sm font-bold">×</span>
//                             </button>

//                             <p className="text-sm text-gray-700 pr-8 leading-relaxed group-hover/notification:text-gray-900 transition-colors duration-300">
//                               {doc.data.message}
//                             </p>

//                             {/* Animated bottom border */}
//                             <div className="absolute bottom-0 left-6 right-6 h-0.5 bg-gradient-to-r from-transparent via-[#1ea1f3]/30 to-transparent transform scale-x-0 group-hover/notification:scale-x-100 transition-transform duration-500"></div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 {/* Enhanced Add Button */}
//                 <button
//                   onClick={handleAddItem}
//                   className="bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-6 py-3 rounded-2xl font-medium transition-all duration-500 flex items-center space-x-2 shadow-lg hover:shadow-xl transform hover:-translate-y-1 relative overflow-hidden group/add-btn"
//                 >
//                   {/* Animated shine effect */}
//                   <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/add-btn:translate-x-[100%] transition-transform duration-1000"></div>

//                   {/* Pulse animation */}
//                   <div className="absolute inset-0 rounded-2xl border-2 border-white/30 transform scale-105 opacity-0 group-hover/add-btn:opacity-100 group-hover/add-btn:scale-100 transition-all duration-500"></div>

//                   <svg className="h-5 w-5 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                   </svg>
//                   <span className="relative z-10 font-semibold">Add New</span>
//                 </button>

//                 {/* Enhanced User Profile */}
//                 <a
//                   href={Crmroutes.Profile.path}
//                   className="flex items-center space-x-3 hover:bg-gradient-to-r from-[#1ea1f3]/10 to-[#1ea1f3]/5 rounded-2xl p-3 transition-all duration-500 group/profile relative overflow-hidden"
//                 >
//                   {/* Background animation */}
//                   <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-x-0 group-hover/profile:scale-x-100 transition-transform duration-500 origin-left"></div>

//                   <span className="text-sm font-semibold text-gray-900 relative z-10 transition-colors duration-300 group-hover/profile:text-white">
//                     {user.name}
//                   </span>

//                   <div className="relative">
//                     {/* Avatar glow effect */}
//                     <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/70 rounded-full opacity-0 group-hover/profile:opacity-100 transition-opacity duration-500 transform group-hover/profile:scale-110 blur-sm"></div>

//                     <img
//                       src={user ? user.photoURL || img : img2}
//                       alt="User Avatar"
//                       className="w-9 h-9 rounded-full border-2 border-gray-200 group-hover/profile:border-white/50 relative z-10 transition-all duration-500 transform group-hover/profile:scale-110"
//                       onError={(e) => {
//                         e.currentTarget.src = img2;
//                       }}
//                     />

//                     {/* Online indicator */}
//                     <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white z-20 group-hover/profile:border-[#1ea1f3] transition-colors duration-300"></div>
//                   </div>
//                 </Link>
//               </div>
//             ) : (
//               <div className="hidden lg:flex items-center">
//                 <button
//                   className="bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-8 py-3 rounded-2xl font-semibold transition-all duration-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden group/get-started"
//                   onClick={handleLoginClick}
//                 >
//                   {/* Shine effect */}
//                   <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/get-started:translate-x-[100%] transition-transform duration-1000"></div>

//                   <span className="relative z-10">Get Started</span>

//                   {/* Pulse border */}
//                   <div className="absolute inset-0 rounded-2xl border-2 border-white/30 transform scale-105 opacity-0 group-hover/get-started:opacity-100 group-hover/get-started:scale-100 transition-all duration-500"></div>
//                 </button>
//               </div>
//             )}

//             {/* Enhanced Mobile menu button */}
//             <div className="lg:hidden">
//               <button
//                 onClick={handleClick}
//                 className="p-3 rounded-2xl text-gray-600 hover:text-white transition-all duration-500 relative group/mobile-btn overflow-hidden"
//               >
//                 {/* Background fill */}
//                 <div className="absolute inset-0 bg-gradient-to-br from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-0 group-hover/mobile-btn:scale-100 transition-transform duration-500"></div>

//                 <img
//                   src={toggle ? close : hamburgerMenu}
//                   alt="Toggle Menu"
//                   className="h-6 w-6 relative z-10 transition-transform duration-300 group-hover/mobile-btn:scale-110"
//                 />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Enhanced Mobile Navigation Menu */}
//         <div className={`lg:hidden transition-all duration-700 ease-out overflow-hidden ${
//           toggle ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
//         }`}>
//           <div className="bg-gradient-to-b from-white/95 to-blue-50/95 backdrop-blur-lg border-t border-blue-100/30 px-4 py-6 space-y-2">
//             {navigationItems.map((item, index) => (
//               <div key={index}>
//                 {!item.hasDropdown ? (
//                   <a
//                     href={item.path}
//                     className="block px-6 py-4 text-gray-800 hover:text-white rounded-2xl transition-all duration-500 font-medium group/mobile-item relative overflow-hidden"
//                   >
//                     {/* Mobile item background fill */}
//                     <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/80 rounded-2xl transform scale-x-0 group-hover/mobile-item:scale-x-100 transition-transform duration-500 origin-left"></div>

//                     {/* Left border indicator */}
//                     <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#1ea1f3] to-[#1ea1f3]/50 rounded-r-full transform scale-y-0 group-hover/mobile-item:scale-y-100 transition-transform duration-500 origin-top"></div>

//                     <span className="relative z-10 flex items-center transition-transform duration-300 group-hover/mobile-item:translate-x-3">
//                       {item.name}
//                     </span>

//                     {/* Right arrow */}
//                     <svg
//                       className="absolute right-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-white opacity-0 group-hover/mobile-item:opacity-100 transition-all duration-500"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                     </svg>
//                   </Link>
//                 ) : (
//                   <div className="space-y-1">
//                     <div className="px-6 py-3 text-gray-900 font-semibold text-sm">
//                       {item.name}
//                     </div>
//                     <div className="space-y-1 pl-4">
//                       {item.dropdownItems.map((dropdownItem, dropdownIndex) => (
//                         <a
//                           key={dropdownIndex}
//                           href={dropdownItem.path}
//                           className="block px-4 py-3 text-gray-700 hover:text-white rounded-xl transition-all duration-500 text-sm group/mobile-dropdown relative overflow-hidden"
//                         >
//                           <div className="absolute inset-0 bg-gradient-to-r from-[#1ea1f3]/80 to-[#1ea1f3]/60 rounded-xl transform scale-x-0 group-hover/mobile-dropdown:scale-x-100 transition-transform duration-500 origin-left"></div>
//                           <span className="relative z-10 flex items-center gap-2">
//                             {dropdownItem.icon && <span>{dropdownItem.icon}</span>}
//                             <span className="group-hover/mobile-dropdown:text-white">{dropdownItem.name}</span>
//                           </span>
//                         </Link>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ))}

//             {!user && (
//               <button
//                 className="w-full mt-4 bg-gradient-to-r from-[#1ea1f3] to-[#1ea1f3]/90 hover:from-[#1ea1f3] hover:to-[#1ea1f3] text-white px-6 py-4 rounded-2xl font-semibold transition-all duration-500 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 relative overflow-hidden group/mobile-get-started"
//                 onClick={handleLoginClick}
//               >
//                 <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover/mobile-get-started:translate-x-[100%] transition-transform duration-1000"></div>
//                 <span className="relative z-10">Get Started</span>
//               </button>
//             )}
//           </div>
//         </div>
//       </nav>

//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 6px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: linear-gradient(to bottom, #f1f1f1, #e3f2fd);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: linear-gradient(to bottom, #1ea1f3, #1ea1f3/80);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: #1ea1f3;
//         }

//         /* Smooth transitions for all elements */
//         * {
//           transition-property: color, background-color, border-color, transform, opacity;
//           transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Navbar;
